<template>
  <el-checkbox-group v-bind="props" :value="tjbForm[key]" @change="onChange">
    <el-checkbox
      v-for="city in options"
      :label="city.displayName"
      :key="city.value"
      :value="city.value"
      :checked="defaultValue === city.value"
    />
  </el-checkbox-group>
</template>

<script>
import storeMixins from '../store-mixins'
export default {
  mixins: [storeMixins],
  props: ['props'],
  data() {
    return {
      isHasOptionsComp: true,
    }
  },
  computed: {
    key() {
      return this.props.name
    },
    defaultValue() {
      return this.props.dataSource.defaultValue;
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {}
      newFormFields[this.key] = v
      this.updateTjbForm(newFormFields)
    },
  },
};
</script>